import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M4 15.243a.75.75 0 01.75.75V19c0 .138.112.25.25.25h14a.25.25 0 00.25-.25v-3.007a.75.75 0 011.5 0V19A1.75 1.75 0 0119 20.75H5A1.75 1.75 0 013.25 19v-3.007a.75.75 0 01.75-.75z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M19.87 10.893c.3.286.311.76.025 1.06l-3.047 3.199a.75.75 0 01-1.086 0l-3.048-3.198a.75.75 0 111.086-1.035l2.505 2.628 2.504-2.628a.75.75 0 011.06-.026z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M11.352 4.75A4.202 4.202 0 007.15 8.952v5.006a.75.75 0 01-1.5 0V8.952a5.702 5.702 0 0111.405 0v5.006a.75.75 0 01-1.5 0V8.952a4.202 4.202 0 00-4.203-4.202z",
      "clip-rule": "evenodd"
    })
  ]))
}